import React  from 'react';
import { Layout } from 'antd';
import './GraphicSider.css'; // Make sure to define the necessary CSS styles

const { Sider } = Layout;

const GraphicSider = ({
  children,
  imgUrl,
  linearGradient,
  overlay = 'rgba(0, 0, 0, 0)',
  width = 200,
  borderRadius='8px',
    className=''
}) => {
  const backgroundStyle = imgUrl ? { backgroundImage: `url(${imgUrl})` } : { backgroundImage: linearGradient };

  return (
    <Sider width={width}
           className={`graphic-sider ${className}`}
           style={{
             ...backgroundStyle,
             borderRadius: borderRadius,
             maxHeight: '100vh',
    }}>
      <div className="graphic-sider-overlay" style={{ background: overlay }}>
        {children}
      </div>
    </Sider>
  );
};

export default GraphicSider;
